/* eslint-env browser */
import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

import './styles/App.scss';

ReactDOM.render(<App />, document.getElementById('root'));
